module.exports = "<lfwms-view-my-print-jobs-search></lfwms-view-my-print-jobs-search>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/view-my-print-jobs/view-my-print-jobs-home.component.html
// module id = ../../../../../src/app/features/reports/view-my-print-jobs/view-my-print-jobs-home.component.html
// module chunks = main